export default __webpack_public_path__ + "static/media/image_pig_nomoney.b2a2e612.png";